export type VersionInfo = Readonly<{
  tag: string;
  hash: string;
}>;

export const versionInfo: VersionInfo = (() => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return require('../git-version.json');
  } catch {
    // In dev the file might not exist:
    return { tag: 'v0.0.0', hash: 'dev' };
  }
})();
